import * as React from 'react';
import Checkbox from 'antd/lib/checkbox';
import withStyles from 'react-jss';
import { commonStyles } from 'src/Library/CommonStyles';
const styles = theme => ({
  ...commonStyles(theme),
});

const SelectServices = (props) => {
  const {
    options,
    onChange,
    value,
    style,
    classes,
    disabled,
    className,
  } = props;

  const getOptions = () => {
    return options?.map(item => ({
      value: item,
      label: item,
    }) || []);
  };

  return <Checkbox.Group
    onChange={onChange}
    disabled={disabled}
    value={value}
    style={style}
    options={getOptions()}
    className={[className, classes.checkbox].join(' ')}
  />;
};

export default React.memo(withStyles(styles)(SelectServices));